var React = require('react');

function ExternalLinkSquareAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16 200c0 21.45-25.94 32-41 17l-32-32-195.48 195.48a12 12 0 0 1-17 0l-31-31a12 12 0 0 1 0-17L263 169l-32-32c-15.11-15.11-4.34-41 17-41h112a24 24 0 0 1 24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384 232c0 21.44-25.94 32-41 17l-32-32-195.48 195.48a12 12 0 0 1-17 0l-31-31a12 12 0 0 1 0-17L263 169l-32-32c-15.11-15.11-4.34-41 17-41h112a24 24 0 0 1 24 24z","className":"fa-primary","key":2})]);
}

ExternalLinkSquareAlt.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ExternalLinkSquareAlt;

ExternalLinkSquareAlt.default = ExternalLinkSquareAlt;
